import React, { useState } from 'react';
import '../css/portfolio.css';
import FadeInSection from '../components/FadeInSection';

const CATEGORIES = ['All', 'Branding', 'Digital Marketing', 'Website', 'Media Production', 'Event', 'Graphic Design'];

export default function Portfolio() {
  const [active, setActive] = useState('All');

  return (
    <div className="portfolio-page">
      <FadeInSection direction="up">
      <section className="portfolio-hero">
        <div className="container">
          <span className="section-tag">Our Work</span>
          <h1>Portfolio</h1>
          <p className="section-sub">A selection of projects we're proud of.</p>
        </div>
      </section>
      </FadeInSection>

      <FadeInSection direction="left">
      <section className="section section-white">
        <div className="container">
          <div className="portfolio-filters">
            {CATEGORIES.map(c => (
              <button key={c} className={`filter-btn ${active === c ? 'active' : ''}`} onClick={() => setActive(c)}>{c}</button>
            ))}
          </div>
          <div className="portfolio-empty">
            <div className="empty-icon">🖼️</div>
            <p>Portfolio items will appear here.</p>
            <span>Managed from the admin panel.</span>
          </div>
        </div>
      </section>
      </FadeInSection>
    </div>
  );
}
